import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { EnvironmentProvider } from './EnvironmentProvider'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <EnvironmentProvider>
      <App />
    </EnvironmentProvider>
  </StrictMode>,
)